<template>
  <div class="bg-white mt-5 p-5">
    <el-form
      label-position="left"
      size="medium"
      label-width="80px"
      :model="formData"
      :rules="currentRules"
      ref="form"
    >
      <el-form-item
        label="广告账户"
        prop="accountId"
      >
        <account :currentAccount="createAdAccount"></account>
      </el-form-item>
      <el-form-item prop="campaignTraceConfig.utmSourceConfig">
        <campaignTraceConfig
          :value="campaignTraceConfigData"
          @input="changeCampaignTraceConfig"
        />
      </el-form-item>
      <el-form-item
        label="推广连接"
        prop="promotionLink"
      >
        <!-- <el-row>
          <el-col :span="24"> -->
        <el-input
          v-model="formData.promotionLink"
          @blur="onChangePromotionLink"
          v-loading="promotionLinkLoading"
          @keyup.enter.native="
            (e) => {
              e.target.blur();
            }
          "
        ></el-input>
        <!-- </el-col>
          <el-col :span="2"> -->
        <el-button
          type="text"
          @click="openLink"
          class="w-[80px]"
          >预览</el-button
        >
        <!-- </el-col>
        </el-row> -->
      </el-form-item>
      <el-form-item
        label="商品id"
        prop="sale"
      >
        <sale :sale-info="formData.sale"></sale>
      </el-form-item>
      <el-form-item
        label="站点信息"
        prop="site"
      >
        <site
          v-model="formData.site"
          disabled
        ></site>
      </el-form-item>
    </el-form>
    <campaignBudget
      ref="campaignBudget"
      :currentAccount="currentAccount"
      :enumConstants="enumConstants"
      v-model="formData"
      @change="onChange"
    />
  </div>
</template>

<script>
// import selectAccount from '@/components/create/selectAccount.vue';
import account from '@/views/google/create/components/campaignInfo/components/account.vue';
import campaignBudget from '@/views/google/create/components/campaignInfo/components/campaignBudget.vue';
import campaignTraceConfig from '@/views/google/create/components/campaignInfo/components/campaignTraceConfig.vue';
import sale from '@/components/create/sale.vue';
import site from '@/components/create/site.vue';
import { promoteInfo } from '@/api/google/create.js';
import { rules, regUrl } from './index';
import { mapState } from 'vuex';
import { checkGoogleSaleRisk, googleAccountId, googleAccountName } from '@/components/google/riskLevelCheck';

export default {
  props: {
    value: Object,
    currentAccount: Object,
    enumConstants: Object,
  },
  components: {
    account,
    sale,
    site,
    campaignTraceConfig,
    campaignBudget,
  },
  data() {
    return {
      promotionLinkLoading: false,
      formData: {},
      riskCheckedKey: '',
      riskCheckSeq: 0,
      campaignTraceConfigData: {},
      loadingPixel: false,
      pixelList: [],
    };
  },
  computed: {
    ...mapState('google', ['createAdAccount']),
    saleRiskToken() {
      const saleId = this.formData.sale && this.formData.sale.saleId;
      return googleAccountId(this.createAdAccount) + '\0' + (saleId == null ? '' : saleId);
    },
    currentRules() {
      return {
        ...rules,
        'campaignTraceConfig.utmSourceConfig': [
          {
            required: this.campaignTraceConfigData.enable,
            message: '请选择推广渠道',
            trigger: 'change',
          },
        ],
      };
    },
  },
  methods: {
    onChangePromotionLink() {
      if (!this.formData.promotionLink || !this.formData.promotionLink.trim()) {
        this.$set(this.formData, 'sale', null);
        this.$set(this.formData, 'site', null);
      }
      let params = {
        promotionLink: this.formData.promotionLink.trim(),
        utmSourceConfig: this.createAdAccount.utmSourceConfig,
      };
      if (!regUrl.test(this.formData.promotionLink)) {
        return;
      }

      this.promotionLinkLoading = true;
      this.$set(this.formData, 'sale', null);
      this.$set(this.formData, 'site', null);
      promoteInfo(params)
        .then((res) => {
          if (res.code == 0) {
            this.$set(this.formData, 'site', { ...res.data.site, name: res.data.site.domain });
            this.$set(this.formData, 'sale', { ...res.data.sale, id: res.data.sale.saleId });
            this.$set(this.formData, 'utmSourceConfig', res.data.utmSourceConfig);
          } else {
            this.$set(this.formData, 'sale', null);
            this.$set(this.formData, 'site', null);
            this.$set(this.formData, 'utmSourceConfig', null);

          }
          if (this.value.promoteInfo.promotionLink != this.formData.promotionLink) {
            this.$emit('changePromotionLink', this.formData.promotionLink);
          }
          this.onChange();
        })
        .finally(() => {
          this.promotionLinkLoading = false;
        });
    },
    changeCampaignTraceConfig(val) {
      this.campaignTraceConfigData = val;
      this.formData.campaignTraceConfig = val;
      console.log(this.campaignTraceConfigData);
      //   数据改变之后再往外抛出数据，防止抛出的数据是修改前的数据
      this.$nextTick(() => {
        this.onChange();
      });
      //   this.$emit('changeCampaignTraceConfig', val);
    },
    // 打开链接验证链接是否能打开
    openLink() {
      if (!this.formData.promotionLink) return;
      window.open(this.formData.promotionLink);
    },
    clearResolvedPromotion() {
      this.$set(this.formData, 'sale', null);
      this.$set(this.formData, 'site', null);
      this.$set(this.formData, 'promotionLink', '');
      this.$set(this.formData, 'utmSourceConfig', null);
      this.onChange();
    },
    checkCurrentSaleRisk() {
      const sale = this.formData.sale;
      checkGoogleSaleRisk(this, {
        saleId: sale && sale.saleId,
        accountId: googleAccountId(this.createAdAccount),
        accountName: googleAccountName(this.createAdAccount),
        stillCurrent: (saleId, accountId) => {
          const current = this.formData.sale && this.formData.sale.saleId;
          return String(current) === String(saleId) && googleAccountId(this.createAdAccount) === accountId;
        },
        onCancel: () => this.clearResolvedPromotion(),
      });
    },
    onChange() {
      const {
        accountId,
        promotionLink,
        sale,
        site,
        budgetAmount,
        budgetType,
        bidStrategy,
        bidAmount,
        startDate,
        endDate,
        utmSourceConfig
      } = this.formData;
      const newValue = {
        ...this.value,
        campaignTraceConfig: { ...this.campaignTraceConfigData },
        accountId,
        promoteInfo: {
          promotionLink,
          sale,
          site,
          utmSourceConfig
        },
        budgetAmount,
        budgetType,
        bidStrategy,
        bidAmount,
        startDate,
        endDate,
      };
      console.log(newValue);
      this.$emit('input', {
        ...newValue,
      });
      this.$emit('change', {
        ...newValue,
      });
    },
    // 对外提供的验证
    validate() {
      return Promise.all([this.$refs.form.validate(), this.$refs.campaignBudget.validate()]);
    },
  },
  watch: {
    saleRiskToken() {
      this.checkCurrentSaleRisk();
    },
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        let { budgetAmount, budgetType, bidStrategy, bidAmount, startDate, endDate, promoteInfo } = val;
        this.formData = {
          accountId: this.createAdAccount.id,
          promotionLink: promoteInfo.promotionLink,
          sale: promoteInfo.sale,
          site: promoteInfo.site,
          campaignTraceConfig: { ...val.campaignTraceConfig },
          budgetAmount,
          budgetType,
          bidStrategy,
          bidAmount,
          startDate,
          endDate,
          utmSourceConfig: promoteInfo.utmSourceConfig,
          campaignTraceConfig: { ...val.campaignTraceConfig }
        };
        this.campaignTraceConfigData = { ...val.campaignTraceConfig };
      },
    },
  },
};
</script>
